import { gql } from "@apollo/client";

export const allPaymentBalance = gql`
  query GetPaymentBalanceByCurrentDate {
    getPaymentBalanceByCurrentDate {
      success

      error

      message

      data {
        id
        invoiceNumber
        balance
        customerCode
        customerName
        repName
        repCode
        uploadedAt
        status
        partialPaidAmount
        remainingAmount
        remarks
        user {
          employeeName
        }
      }
    }
  }
`;

export const createPaymentBalance = gql`
  mutation createcustomer($input: CustomerInput!) {
    createCustomer(input: $input) {
      success

      message
    }
  }
`;

export const uploadPaymentBalance = gql`
  mutation UploadCustomers($file: Upload!, $userId: Int!) {
    uploadCustomerList(file: $file, userId: $userId) {
      success

      message
    }
  }
`;

export const exportProductMaster = gql`
  mutation ExportFilteredProducts(
    $startDate: Date!
    $endDate: Date!
    $categories: [String]
    $brands: [String]
    $products: [String]
  ) {
    exportFilteredProduct(
      startDate: $startDate
      endDate: $endDate
      categories: $categories
      brands: $brands
      products: $products
    ) {
      success
      message
      fileUrl
    }
  }
`;

export const uploadProductMaster = gql`
  mutation uploadProductMaster($file: Upload!, $userId: Int!) {
    uploadProductMaster(file: $file, userId: $userId) {
      success

      message
    }
  }
`;

export const allRoles = gql`
  query allRoles {
    allRoles {
      data {
        id
        role
        description
      }
      success
      error
      message
    }
  }
`;

export const allUsers = gql`
  query {
    allUsers {
      id

      employeeName

      employeeCode

      email

      contactNumber

      address

      role {
        id
        role
      }

      department {
        id
        departmentName
      }
      createdAt

      profilePicture

      webUse

      mobileUse
    }
  }
`;

//get allCustomers
export const allCustomers = gql`
  query {
    allCustomers {
      id

      customerCategory

      customerCode

      customerName

      priceCode

      repName

      repCode

      status
    }
  }
`;

export const todayCustomersDropdown = gql`
  query TodayCustomersDropdown {
    todayCustomersDropdown {
      success
      message
      data {
        id
        customerName
        customerCode
        customerCategory
        priceCode
        repName
        repCode
        status
      }
    }
  }
`;
//get allProductCategories
export const allProductCategories = gql`
  query {
    allProductCategories {
      data {
        id

        categoryCode

        categoryName

        categoryDescription

        createdAt

        lastupdate

        user {
          id
        }
      }

      success

      error

      message
    }
  }
`;
//get allBrands
export const allBrands = gql`
  query {
    allBrands {
      data {
        id
        brandName
        brandDescription
        brandLogo
        createdAt
        lastupdate
        user {
          id
        }
      }
      success
      error
      message
    }
  }
`;

//get allProducts
export const allProducts = gql`
  query {
    allProductsDropdown {
      success
      message
      data {
        id
        productName
        productCode
      }
    }
  }
`;

export const allProductsDropdown = gql`
  query {
    allProductsDropdown {
      success
      message
      data {
        id
        productName
        productCode
      }
    }
  }
`;

//filter api
export const FilterProducts = gql`
  query FilterProducts(
  $startDate: Date
  $endDate: Date
  $categories: [String]
  $brands: [String]
  $products: [String]
  $page: Int
  $pageSize: Int
) {
  filterProducts(
   startDate: $startDate
   endDate: $endDate
   categories: $categories
   brands: $brands
   products: $products
   page: $page
   pageSize: $pageSize
  ) {
   success
   message
   totalCount
   currentPage
   totalPages
   hasNextPage
   hasPreviousPage
   data {
     productCode
     productName
     productBrand
     productCategory
     originalStock
     currentStock
     user {
       employeeName
     }
   }
  }
}
`;
// api for SalesOrderFilter
export const SalesOrderFilter = gql`
  query SalesOrderReport(
    $startDate: Date
    $endDate: Date
    $products: [String]
    $customers: [String]
    $status: [String]
    $agents: [String]
  ) {
    salesOrderReport(
      startDate: $startDate

      endDate: $endDate

      products: $products

      customers: $customers

      status: $status

      agents: $agents
    ) {
      success

      message

      data {
        orderSio

        customerName

        totalAmount

        status

        products {
          productName

          quantity

          price

          tax

          amount
        }
      }
    }
  }
`;
//Export exportSalesOrder api
export const exportSalesOrder = gql`
  mutation ExportSalesOrderReport(
    $startDate: Date!
    $endDate: Date!
    $products: [String]
    $customers: [String]
    $status: [String]
    $agents: [String]
  ) {
    exportSalesOrderReport(
      startDate: $startDate

      endDate: $endDate

      products: $products

      customers: $customers

      status: $status

      agents: $agents
    ) {
      success

      message

      fileUrl
    }
  }
`;
// api for PaymentFollowFilter
export const PaymentFollowFilter = gql`
  query PaymentFollowUpReport(
  $startDate: Date
  $endDate: Date
  $customers: [String]
  $agents: [String]
  $page: Int
  $pageSize: Int
) {
  paymentFollowUpReport(
    startDate: $startDate
    endDate: $endDate
    customers: $customers
    agents: $agents
    page: $page
    pageSize: $pageSize
  ) {
    success
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    data {
      customerCode
      customerName
      invoiceNumber
      repName
      balance
      remainingAmount
      status
      createdAt
      partialPaidAmount
      user {
        employeeName
      }
    }
  }
}
`;
//Export exportPaymentFollow api
export const exportPaymentFollow = gql`
  mutation ExportFilteredPaymentBalances(
    $startDate: Date!
    $endDate: Date!
    $customers: [String]
    $agents: [String]
  ) {
    exportFilteredPaymentBalances(
      startDate: $startDate

      endDate: $endDate

      customers: $customers

      agents: $agents
    ) {
      success

      message

      fileUrl
    }
  }
`;

//filter outstatnding balance
export const FilterBalance = gql`
  query FilterPaymentBalances(
  $startDate: Date
  $endDate: Date
  $customers: [String]
  $agents: [String]
  $page: Int
  $pageSize: Int
) {
  filterPaymentBalances(
   startDate: $startDate
   endDate: $endDate
   customers: $customers
   agents: $agents
   page: $page
   pageSize: $pageSize
  ) {
   success
   message
   totalCount
   currentPage
   totalPages
   hasNextPage
   hasPreviousPage
   data {
     customerCode
     customerName
     repName
     invoiceNumber
     balance
     partialPaidAmount
     remainingAmount
     createdAt
     user {
       employeeName
     }
   }
  }
}
`;

//Export realtime inventory api
export const exportInventoryMaster = gql`
  mutation ExportFilteredProducts(
    $startDate: Date!
    $endDate: Date!
    $categories: [String]
    $brands: [String]
    $products: [String]
  ) {
    exportFilteredProduct(
      startDate: $startDate
      endDate: $endDate
      categories: $categories
      brands: $brands
      products: $products
    ) {
      success
      message
      fileUrl
    }
  }
`;

//Export realtime inventory api
export const exportBalanceMaster = gql`
  mutation ExportFilteredProducts(
    $startDate: Date!
    $endDate: Date!
    $categories: [String]
    $brands: [String]
    $products: [String]
  ) {
    exportFilteredProduct(
      startDate: $startDate
      endDate: $endDate
      categories: $categories
      brands: $brands
      products: $products
    ) {
      success
      message
      fileUrl
    }
  }
`;

//get sample feedback data
export const GetAllProductFeedbacks = gql`
  query GetAllProductFeedbacks($filter: ProductFeedbackFilterInput) {
    getAllProductFeedbacks(filter: $filter) {
      success
      error
      message
      data {
        id
        feedbackCollectedDate
        overallRating
        sample {
          id
          customer {
            customerName
          }
          product {
            productName
          }
        }
      }
    }
  }
`;

//get filter sample feedback data
export const FilterProductFeedback = gql`
  query FilterProductFeedback($filters: ProductFeedbackFilterReportInput) {
    filterProductFeedback(filters: $filters) {
      success
      error
      message
      data {
        id
        feedbackCollectedDate
        productQualityRating
        packagingQualityRating
        valueForMoneyRating
        overallRating
        suggestedImprovements
        purchaseIntent
        submittedAt
        submittedBy {
          id
          username
        }
        sample {
          id
          sampleProvidedDate
          product {
            id
            productName
          }
          customer {
            id
            customerName
            user {
              id
              username
            }
          }
          createdBy {
            id
            employeeName
          }
        }
      }
    }
  }
`;

// Export sample feedback data
export const ExportProductFeedback = gql`
  mutation ExportProductFeedbackReport(
    $startDate: Date
    $endDate: Date
    $productNames: [String]
    $customerNames: [String]
    $overallRatings: [Int]
    $agentNames: [String]
  ) {
    ExportProductFeedbackReport(
      startDate: $startDate
      endDate: $endDate
      productNames: $productNames
      customerNames: $customerNames
      overallRatings: $overallRatings
      agentNames: $agentNames
    ) {
      success
      message
      fileUrl
    }
  }
`;

//get Export sample feedback data
export const ExportReturns = gql`
  mutation ExportReturnsReport(
    $startDate: Date!
    $endDate: Date!
    $customerName: String
    $agentIds: [Int]
    $status: String
  ) {
    exportReturnsReport(
      startDate: $startDate
      endDate: $endDate
      customerName: $customerName
      agentIds: $agentIds
      status: $status
    ) {
      success
      fileUrl
      message
    }
  }
`;

//get all delivery data
export const getAllDeliveries = gql`
  query {
    allDeliveries {
      id
      deliveryId
      salesOrder
      repName
      repCode
      customerName
      customerAddress
      typeOfCreation
      deliveryStatus
      visitStatus
      deliveredDate
      deliveredOn
      reason
      contactPerson
      contactNumber
      paymentMode
      createdAt
      updatedAt
      deliveryProducts {
        id
        productCode
        productName
        quantity
        createdAt
        updatedAt
      }
    }
  }
`;

//Filter Return data
export const GetReturnsReport = gql`
  query GetReturnsReport(
    $startDate: Date
    $endDate: Date
    $customerNames: [String]
    $agentIds: [Int]
    $status: String
  ) {
    getReturnsReport(
      startDate: $startDate
      endDate: $endDate
      customerNames: $customerNames
      agentIds: $agentIds
      status: $status
    ) {
      success
      error
      message
      data {
        id
        salesOrder
        isOldSo
        customerName
        status
        reason
        approvedOrRejectedAt
        createdAt
        updatedAt
        customerName
        user {
          employeeName
        }
        deliveryAgent {
          id
          employeeName
        }
      }
    }
  }
`;

//Filter stock expiry data
export const StockExpiryReport = gql`
  query StockExpiryReport(
    $startDate: Date
    $endDate: Date
    $productIds: [Int]
    $marketNames: [String]
    $agentIds: [Int]
  ) {
    getStockExpiryReport(
      startDate: $startDate
      endDate: $endDate
      productIds: $productIds
      marketNames: $marketNames
      agentIds: $agentIds
    ) {
      success
      error
      message
      data {
        id
        marketName
        address
        contactPerson
        contactNumber
        contractStart
        contractEnd
        completeWithin
        agent {
          id
          username
          employeeName
        }
        agreedProducts {
          id
          quantity
          productCategory
          product {
            id
            productName
            productCategory
          }
          reconciliationSet {
            id
            actualQuantity
            batchExpiry
            retailPrice
            remarks
            saved
            submitted
            imageBefore
            imageAfter
          }
        }
        remarkSet {
          id
          text
          approvedStatus
          submittedBy {
            id
            employeeName
          }
        }
      }
    }
  }
`;

//Expoert stock expiry data
export const ExportStockExpiryReport = gql`
  mutation ExportStockExpiryReport(
    $startDate: Date!
    $endDate: Date!
    $productIds: [Int]
    $marketNames: [String]
    $agentIds: [Int]
  ) {
    exportStockExpiryReport(
      startDate: $startDate
      endDate: $endDate
      productIds: $productIds
      marketNames: $marketNames
      agentIds: $agentIds
    ) {
      success
      error
      message
      fileUrl
    }
  }
`;

//Filter Delivery data
export const deliveryReport = gql`
  query deliveryReport($input: DeliveryReportFilterInput) {
    deliveryReport(filters: $input) {
      success
      message
      data {
        id
        deliveryId
        salesOrder {
          id
          soNumber
        }
        repName
        repCode
        customerName
        customerAddress
        typeOfCreation
        deliveryStatus
        visitStatus
        deliveredDate
        deliveredOn
        reason
        contactPerson
        contactNumber
        paymentMode
        createdAt
        updatedAt
        deliveryProducts {
          id
          productCode
          productName
          quantity
          createdAt
          updatedAt
        }
      }
    }
  }
`;

//Expoert Delivery data
export const exportdeliveryreport = gql`
  mutation exportdeliveryreport($startdate: Date!, $enddate: Date!) {
    exportDeliveryReport(startDate: $startdate, endDate: $enddate) {
      success
      message
      fileUrl
    }
  }
`;

//Filter New customer report data
export const NewCustomerProposalReport = gql`
  query NewCustomerProposalReport(
    $startDate: Date
    $endDate: Date
    $customerNames: [String]
    $agents: [String]
  ) {
    newCustomerProposalReport(
      startDate: $startDate
      endDate: $endDate
      customerNames: $customerNames
      agents: $agents
    ) {
      success
      message
      error
      data {
        customerCode
        customerName
        customerCategory
        phoneNo
        email
        address
        startDate
        agentName
        priceCode
        locationLat
        locationLng
        createdAt
      }
    }
  }
`;

export const MerchandiseComplianceReport = gql`
  query MerchandiseComplianceReport(
    $startDate: Date
    $endDate: Date
    $marketNames: [String]
    $agentIds: [Int]
    $actualQuantityPercents: [String]
    $page: Int
    $pageSize: Int
  ) {
    getMerchandiseComplianceReport(
      startDate: $startDate
      endDate: $endDate
      marketNames: $marketNames
      agentIds: $agentIds
      actualQuantityPercents: $actualQuantityPercents
      page: $page
      pageSize: $pageSize
    ) {
      success
      message
      error
      totalCount
      totalPages
      currentPage
      data {
        marketName
        agentName
        productName
        agreedQuantity
        actualQuantity
        actualQuantityPercent
        batchExpiry
        remarks
        complianceStatus
        submitted
      }
    }
  }
`;

export const ExportMerchandiseComplianceReport = gql`
  mutation ExportMerchandiseComplianceReport(
    $startDate: Date!
    $endDate: Date!
    $marketNames: [String]
    $agentIds: [Int]
    $actualQuantityPercents: [String]
  ) {
    exportMerchandiseComplianceReport(
      startDate: $startDate
      endDate: $endDate
      marketNames: $marketNames
      agentIds: $agentIds
      actualQuantityPercents: $actualQuantityPercents
    ) {
      success
      fileUrl
      message
    }
  }
`;

export const GetCompetitorAnalysisReport = gql`
  query GetCompetitorAnalysisReport(
    $startDate: Date!
    $endDate: Date!
    $productNames: [String]
    $brands: [String]
    $categories: [String]
    $agents: [String]
  ) {
    getCompetitorAnalysisReport(
      startDate: $startDate
      endDate: $endDate
      productNames: $productNames
      brands: $brands
      categories: $categories
      agents: $agents
    ) {
      success
      message
      error
      data {
        productCode
        productName
        productBrand
        productCategory
        competitorPrice
        agentName
        createdAt
        lastupdate
        productImage
      }
    }
  }
`;

export const ExportCompetitorReport = gql`
  mutation ExportCompetitorReport($startDate: Date!, $endDate: Date!) {
    exportCompetitorAnalysisReport(startDate: $startDate, endDate: $endDate) {
      success
      fileUrl
      message
    }
  }
`;

//filter Slow Moving Product Report
export const SlowMovingProductReport = gql`
  query SlowMovingProductReport(
    $startDate: Date
    $endDate: Date
    $productCategories: [String]
    $brands: [String]
    $userIds: [Int]
    $agentNames: [String]
    $agesOfStock: [Int]
    $productNames: [String]
  ) {
    slowMovingProductReport(
      startDate: $startDate
      endDate: $endDate
      productCategories: $productCategories
      brands: $brands
      userIds: $userIds
      agentNames: $agentNames
      agesOfStock: $agesOfStock
      productNames: $productNames
    ) {
      success
      error
      message
      data {
        id
        productCode
        productName
        brand
        productCategory
        ageOfStock
        reasonForSlowMovement
        createdAt
        user {
          id
          username
          email
        }
      }
    }
  }
`;

//export Slow Moving Product Report
export const ExportSlowMovingProductReport = gql`
  mutation ExportSlowMovingProductReport(
    $startDate: Date
    $endDate: Date
    $productCategories: [String]
    $brands: [String]
    $productNames: [String]
    $agentNames: [String]
    $userIds: [Int]
    $agesOfStock: [String]
  ) {
    exportSlowMovingProductReport(
      startDate: $startDate
      endDate: $endDate
      productCategories: $productCategories
      brands: $brands
      productNames: $productNames
      agentNames: $agentNames
      userIds: $userIds
      agesOfStock: $agesOfStock
    ) {
      success
      message
      fileUrl
    }
  }
`;

export const realtimeinventeryList = gql`
  query {
    todayDateProductsDropdown {
      success
      message
      data {
        id
        productCode
        productName
        productCategory
        productBrand
        productUom
        soldStock
        currentStock
        originalStock
        conversion
        stockInCtn
        stockInPart
        createdAt
        user {
          employeeName
        }
      }
    }
  }
`;
